import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import "./assets/scss/variable.scss";
import "./assets/scss/style.scss";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { Header } from "./components/header";
import { Footer } from "./components/footer";
import { Home } from "./pages/home";
import { About } from "./pages/about";
import { Contact } from "./pages/contact";
import { Blog } from "./pages/blog";
import { Portfolio } from "./pages/portfolio";
import { ReactNative } from "./pages/react-native";
import { IOS } from "./pages/ios";
import { IpadTablet } from "./pages/ipad";
import { Android } from "./pages/android";
import { Flutter } from "./pages/flutter";
import { BlogDetail } from "./pages/blog-details";

function App() {
  return (
    <div className="App">
      <Router basename="/">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/*" element={<Home />}></Route>
          <Route path="/about-us" element={<About />}></Route>
          <Route path="/contact-us" element={<Contact />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
          <Route path="/blog-detail" element={<BlogDetail />}></Route>
          <Route path="/portfolio" element={<Portfolio />}></Route>
          <Route path="/react-native" element={<ReactNative />}></Route>
          <Route path="/ios" element={<IOS />}></Route>
          <Route path="/android" element={<Android />}></Route>
          <Route path="/ipad-tablet" element={<IpadTablet />}></Route>
          <Route path="/flutter" element={<Flutter />}></Route>
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
